import { STATIC_TEAM_DATA } from '../shared/data/staticData';

export interface TeamMember {
  id: string;
  first_name: string;
  last_name: string;
  url: string | null;
  designation: string;
  rank: number;
  status: string;
}

export interface TeamData {
  [category: string]: TeamMember[];
}

export const fetchTeamMembers = async (): Promise<TeamData> => {
  try {
    return STATIC_TEAM_DATA.users as TeamData || {};
  } catch (error) {
    console.error('Error fetching team members:', error);
    return {};
  }
};